import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { CrearSedeDto } from '../shared/models/crear-sede-dto';
import { ErrorDto } from '../shared/models/error-dto';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { SesionService } from '../shared/services/sesion.service';
import { BuscarSedeDto } from '../shared/models/buscar-sede-dto';
import { MultiSelectModule } from 'primeng/multiselect';
import { VlanSede } from '../shared/models/vlan-sede-dto';
import { VlanSedeService } from '../shared/services/vlanSede.service';

@Component({
  selector: 'app-crear-sede',
  templateUrl: './crear-sede.component.html',
  styleUrls: ['./crear-sede.component.css']
})
export class CrearSedeComponent implements OnInit {

  principalForm = this.formBuilder.group({
    selectCompania: new FormControl(),
    CiudadControl: new FormControl(),
    NombreSedeControl: new FormControl(),
    companiaOptions: new FormControl()
  });

  companias: Compania[];
  companiasSeleccionadas: Compania[] = new Array<Compania>();
  ciudades: Ciudad[];
  ciudadesFiltradas: Ciudad[];
  ciudadSeleccionada: Ciudad = new Ciudad();
  sedeCrear: Sede = new Sede();
  crearSedeDto: CrearSedeDto = new CrearSedeDto();
  nombreSede = '';
  modalRef: NgbModalRef;
  errorDto: ErrorDto;
  mensajeAlerta = '';
  sedes: BuscarSedeDto[] = new Array<BuscarSedeDto>();
  idCiudadBuscar = -1;
  nombreSedeBuscar = '-1';
  listaIdCompanias: number[] = new Array<number>();
  sedeSeleccionada: BuscarSedeDto = new BuscarSedeDto();
  indexSeleccionado: number;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private sesionService: SesionService, private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    console.log(this.principalForm);
    this.listarCompanias();
    this.listarCiudades();
    this.ciudadSeleccionada=null;
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudades(): void {
    this.ciudadService.listarCiudades().subscribe(
      resultado => {
        this.ciudades = resultado;
        this.ciudadesFiltradas = this.ciudades;
      }
    );
  }


  public filterCiudades(event) {
    this.ciudadesFiltradas = [];
    for (let i = 0; i < this.ciudades.length; i++) {
      const ciudad = this.ciudades[i];
      if (ciudad.nombreCiudad.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.ciudadesFiltradas.push(ciudad);
      }
    }
  }

  // Metodo que realiza el guardado de la sede y sus relaciones con las companias
  public guardarSede(cargandoModal, alertaModal, resultadoModal) {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    if (!this.validarCampos()) {
      return;
    }
    this.crearSedeDto.sede = new Sede();
    this.crearSedeDto.sede.ciudad = new Ciudad();
    this.crearSedeDto.sede.nombreSede = this.nombreSede;
    this.crearSedeDto.sede.ciudad = this.ciudadSeleccionada;
    this.crearSedeDto.sede.indicadorHabilitado = true;
    this.llenarListaIdCompanias();
    this.sedeService.crearSede(this.crearSedeDto).subscribe(
      resultado => {
        this.crearSedeDto = resultado;
        this.modalRef.close();
        this.modalRef = this.modalService.open(resultadoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
      }, error => {
        this.errorDto = error.error;
        this.modalRef.close();
        this.mensajeAlerta = this.errorDto.mensajeError;
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
      }
    );
  }

  public validarCampos(): boolean {
    if (this.companiasSeleccionadas.length <= 0) {
      return false;
    }
    if (this.ciudadSeleccionada === null) {
      return false;
    }
    if (this.nombreSede === null || this.nombreSede.length < 3) {
      return false;
    }
    return true;
  }

  public llenarListaIdCompanias() {
    this.crearSedeDto.idCompanias = new Array();
    for (const compania of this.companiasSeleccionadas) {
      this.crearSedeDto.idCompanias.push(compania.idCompania);
    }
  }

  public llenarListaIdCompaniasEditar() {
    this.sedeSeleccionada.idCompanias = new Array();
    for (const compania of this.companiasSeleccionadas) {
      this.sedeSeleccionada.idCompanias.push(compania.idCompania);
    }
  }

  public actualizarSeleccionadas(companiaOption: Compania) {
    let existe = false;
    if (this.companiasSeleccionadas.length > 0) {
      for (const compania of this.companiasSeleccionadas) {
        if (companiaOption.idCompania == compania.idCompania) {
          const indexCompania = this.companiasSeleccionadas.indexOf(companiaOption);
          this.companiasSeleccionadas.splice(indexCompania, 1);
          existe = true;
          break;
        }
      }
    }
    if (!existe) {
      this.companiasSeleccionadas.push(companiaOption);
    }
  }

  public ocultarModalResultado() {
    this.principalForm.controls['companiaOptions'].reset();
    this.ciudadSeleccionada = new Ciudad();
    this.ciudadSeleccionada.nombreCiudad = '';
    this.nombreSede = '';
    this.nombreSedeBuscar = '';
    this.sedes = new Array<BuscarSedeDto>();
    this.companiasSeleccionadas = new Array<Compania>();
    this.listaIdCompanias = new Array<number>();
    this.modalRef.close();
  }

  public buscarSede(cargandoModal) {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.inicializarParametrosBuscar();
    if (this.ciudadSeleccionada != null && this.ciudadSeleccionada.idCiudad != null) {
      this.idCiudadBuscar = this.ciudadSeleccionada.idCiudad;
    }
    if (this.nombreSede != null && this.nombreSede != '') {
      this.nombreSedeBuscar = this.nombreSede;
    }
    if (this.companiasSeleccionadas.length > 0) {
      this.listaIdCompanias = new Array<number>();
      this.setearListaIdCompanias();
    }
    this.sedeService.buscarSedes(this.idCiudadBuscar, this.nombreSedeBuscar,
      this.listaIdCompanias).subscribe(
        resultado => {
          this.sedes = resultado;
          this.modalRef.close();
        }
      );
  }

  public inicializarParametrosBuscar() {
    this.idCiudadBuscar = -1;
    this.nombreSedeBuscar = '-1';
    this.listaIdCompanias = [-1];
  }

  public setearListaIdCompanias() {
    for (const compania of this.companiasSeleccionadas) {
      this.listaIdCompanias.push(compania.idCompania);
    }
  }

  public abrirDialogoEditar(editarVlanModal, sede: BuscarSedeDto) {
    this.sedeSeleccionada = new BuscarSedeDto();
    this.indexSeleccionado = this.sedes.indexOf(sede);
    this.sedeSeleccionada.companias = sede.companias;
    this.sedeSeleccionada.estado = sede.estado;
    this.sedeSeleccionada.idSede = sede.idSede;
    this.sedeSeleccionada.nombreCiudad = sede.nombreCiudad;
    this.sedeSeleccionada.nombreSede = sede.nombreSede;
    this.companiasSeleccionadas = new Array<Compania>();
    this.modalRef = this.modalService.open(editarVlanModal, { backdrop: 'static', keyboard: false, size: 'lg' });
  }

  public editarSede(cargandoModal, resultadoModal, alertaModal) {
    if (this.sedeSeleccionada.nombreSede.length > 0) {
      this.modalRef.close();
      this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
      this.llenarListaIdCompaniasEditar();
      this.sedeService.editarSede(this.sedeSeleccionada).subscribe(
        resultado => {
          this.sedeSeleccionada = resultado;
          this.sedes[this.indexSeleccionado] = this.sedeSeleccionada;
          this.modalRef.close();
          this.modalRef = this.modalService.open(resultadoModal, { size: 'lg' });
        }, error => {
          this.modalRef.close();
          this.errorDto = error.error;
          this.mensajeAlerta = this.errorDto.mensajeError;
          this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/crear-sede/crear-sede.component.ts